import moment from 'moment'

export default date => moment(date).format('ddd, MMM D, YYYY')
